
import { User, findUserByDomain } from '../../apis/mgmt/api';
import { readOnly, useReadOnly } from '../common/DataView';
import { useApiFilteredPaginatedList } from '../common/FilteredPaginatedList';
import { ListProps, ListWithCreateButtonLayout, useStatefulList } from '../common/List';
import { useStatefulPaging } from '../common/Paging';
import { UserCard } from './UserCard';

export const useUserListByDomain = function (props: {
    domainId: string | undefined,
}) {
    return useApiFilteredPaginatedList<string, User>({
        filterProps: useReadOnly(props.domainId),
        listProps: useStatefulList<User>(),
        pagingProps: useStatefulPaging(),
        filterToQueryParams: (domainId: string) => ( {domainId} ),
        apiQueryFunc: findUserByDomain
    });
};

export function UserSectionList(props: ListProps<User>) {

    const { onAddItem, onEditItem } = props;

    return (
        <ListWithCreateButtonLayout onCreateClick={onAddItem} >
            {props.data && props.data.map((itemData: User, index: number) => (
                <UserCard
                    key={itemData.id}
                    data={itemData} {...readOnly}
                    onClick={onEditItem}
                />
            ))}
        </ListWithCreateButtonLayout>
    );

}